import React, { Component } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Alert from "react-s-alert";
import moment from "moment";
import classnames from "classnames";
import { api, constant, filterHelper, uiHelper } from "../helpers";
import "./Site.css";
import _ from "lodash";
import Sidebar from "react-sidebar";
import { GiVial } from "react-icons/gi"; 
import { RiFlag2Fill } from "react-icons/ri";
import {
  Row,
  Col,
  Card,
  CardHeader,
  CardBody,
    ListGroup,
    ListGroupItem,
  Badge,
  Collapse,
  Nav,
  NavItem,
} from "reactstrap";
import {
  TextFilter,
  FilterSet,
  SelectFilter,
  ActiveToggleFilter,
  CoaResults,
  CoaSideBarMenu,
  Pager
} from "../components";

const getProducts = () => api.fetch('Reference/Products').then(response => {
  return {
    productList: _.map(response.data, x => { return uiHelper.resolveValue(null, x.id, x.name); })
  };
}).catch(x => console.error(x));
const getFacilities = () => api.fetch('Reference/Facilities').then(response => {
  return {
    facilityList: _.map(response.data, x => { return uiHelper.resolveValue(null, x.id, x.name); })
  };
}).catch(x => console.error(x));
const getProductTypes = () =>
  api
    .fetch("Reference/ProductTypes")
    .then(response => {
      return {
        productTypeList: _.map(response.data, l => { l.label = l.name; l.value = l.id; return l; })
      };
    })
    .catch(x => console.error(x));

const getProductGroups = () =>
  api
    .fetch("Reference/ProductGroups")
    .then(response => {
      return {
        productGroupList: _.map(response.data, l => { l.label = l.name; l.value = l.id; return l; })
      };
    })
    .catch(x => console.error(x));

export default class COADashboard extends Component {
  static displayName = COADashboard.name;

  constructor(props) {
    super(props);
    this.state = {
      filters: [],
      pagedList: null,
      sortColumn: "Id",
      sortAscending: true,
      productList: [],
      facilityList: [],
      productTypeList: [],
      productGroupList: [],
      loading: true,
    };
    this.refreshList = this.refreshList.bind(this);
    this.clearFilters = this.clearFilters.bind(this);
    this.onChangeFilter = this.onChangeFilter.bind(this);
    this.setPage = this.setPage.bind(this);
    this.onProductToggle = this.onProductToggle.bind(this);
    this.markVerified = this.markVerified.bind(this);
    this.downloadReport = this.downloadReport.bind(this);
    this.onVerificationChange = this.onVerificationChange.bind(this);
  }

  componentDidMount() {
    Promise.all([getProducts(), getFacilities(), getProductGroups(), getProductTypes()]).then(response => {
      let newStatus = {};
      _.each(response, r => Object.assign(newStatus, r));
        this.setState(newStatus, () =>this.refreshList()
      //  {
      //  this.onChangeFilter({
      //    filterName: "activeOnly",
      //    value: true,
      //    filteredDisplay: "Active Only"
      //  })
      //}
    );
    });
  }
  refreshList(sortColumn, sortAscending, filters, pageNumber) {
    this.setState({ loading: true }, () => {
    const resolvedFilters = filters || this.state.filters;
    const resolvedSort = {
      sortColumn: sortColumn || this.state.sortColumn,
      sortAscending: sortAscending || this.state.sortAscending
    };
    const payload = {
      activeOnly: null,
      name: null,
      ...resolvedSort,
      ...filterHelper.filtersToObject(resolvedFilters),
      pageSize: 20,
      page: pageNumber || (this.state.pagedList ? this.state.pagedList.pageNumber : 1)
    };
      api.post("COA/COAProductReports", payload)
      .then(response => {
        if (response.data) {
          let list = _.map(response.data.dataSource, l => {
            l.editing = false;
            l.collapse = false;
            l.reports = [];
            l.product = uiHelper.resolveValue(null, l.productId, l.productName);
            //l.facilitySample = uiHelper.resolveValue(null, l.facilitySampleId, l.facilitySampleName);
            return l;
          });
          this.setState({
            ...resolvedSort,
            pagedList: {
              list: list,
              pageNumber: response.data.page,
              pageSize: response.data.pageSize,
              totalItems: response.data.totalItems,
              totalPages: response.data.totalPages
            },
            filters: resolvedFilters,
            loading: false,
          });
        }
      }).catch(error => Alert.error(error));
    })
  }

  getProductIngredientResultList(id, idx, coaRequestProductId) {
    let plist = this.state.pagedList.list.slice();
    let index = _.indexOf(plist, i => { return i.id === id; });

    let payload = {
      COARequestProductId: coaRequestProductId
    };
    api.post("COA/COAReportIngredientResults", payload)
      .then(response => {
        if (response && response.data && response.data.success) {
          plist[index].results = response.data
            ? _.map(response.data, d => {
              d.collapse = false;
              return d;
            })
            : [];
          this.setState({ pagedList: {...this.state.pagedList, list: plist}})
        } else {
          
        }
      });
  }
  setPage(page) {
    this.refreshList(null, null, null, page);
  }

  clearFilters() {
    const filters = [];
    this.setState({ filters: filters });
    this.refreshList(null, null, filters);
  }

  onChangeFilter(changedFilter) {
    const filters = filterHelper.getFilters(
      this.state.filters,
      changedFilter
    );
    this.setState({ filters: filters },
      () => { this.refreshList(null, null, filters, 1) }
    );
  }

  getCOAReportList(id) {
    let plist = this.state.pagedList.list.slice();
    let index = _.indexOf(plist, i => { return i.id === id; });
    let payload = {
      COAProductId: plist[index].coaProductId
    }
    api.post("COA/COAReportResults", payload)
      .then(response => {
        if (response && response.data && response.data.success) {
          plist[index].reports = response.data
            ? _.map(response.data, d => {
              d.collapse = false;
              d.results = [];
              return d;
            })
            : [];
          this.setState({ pagedList: { ...this.state.pagedList, list: plist } })
        }
      });
  }

  onProductToggle(index) {
    let plist = this.state.pagedList.list.slice();
    let isCollapsed = Object.assign({}, plist[index]).collapse;
    if (!isCollapsed) {
      let payload = {
        COAProductId: plist[index].coaProductId
      }
      api.post("COA/COAReportResults", payload)
        .then(response => {
          if (response && response.data) {
            plist[index].reports = response.data
              ? _.map(response.data, d => {
                d.collapse = false;
                d.results = [];
                return d;
              })
              : [];
            this.setState({ pagedList: { ...this.state.pagedList, list: plist } })
          }
        });
    } 
      plist[index].collapse = !plist[index].collapse;
      this.setState({
        pagedList: { ...this.state.pagedList, list: plist }
      });
  }

  onReportToggle(coaIndex, reportIndex) {
    let plist = this.state.pagedList.list.slice();
    let item = Object.assign({}, plist[coaIndex]);
    let isCollapsed = item.reports[reportIndex].collapse;
    if (!isCollapsed) {
      let payload = {
        COARequestProductId: item.reports[reportIndex].coaRequestProductId
      };

      api.post("COA/COAReportIngredientResults", payload)
        .then(response => {
          if (response && response.data) {
              plist[coaIndex].reports[reportIndex].prestineResultList = response.data
              ? _.map(response.data, d => {
                  d.collapse = false;
                  d.resultsOverTimeList = d.resultsOverTime
                    ? _.map(d.resultsOverTime.split(","), d => Number(d))
                    : [];
                  return d;
                })
              : [];
              plist[coaIndex].reports[reportIndex].results =
                  _.reject(plist[coaIndex].reports[reportIndex].prestineResultList.slice(), r => !r.includeInCOAReport);
            this.setState({ pagedList: { ...this.state.pagedList, list: plist } })
          }
        });
    }
        plist[coaIndex].reports[reportIndex].collapse = !isCollapsed;
        this.setState({
          pagedList: { ...this.state.pagedList, list: plist }
        });
    }

  onVerificationChange(event, COAReport){
    //console.log("Product data: ", COAReport);
    //console.log("event here: ", event);
    let changedReport = Object.assign({}, COAReport);
    changedReport.verificationStatusId = event.value;
    let payload = {
      COARequestProductId: changedReport.coaRequestProductId,
      ProductId: changedReport.productId,
      ProductName: changedReport.productName,
      SampleId: changedReport.sampleId,
      SampleName: changedReport.sampleName,
      FacilityId: changedReport.facilityId,
      FacilityName: changedReport.facilityName,
      CheckedByUserName: changedReport.checkedByUserName,
      CheckedAt: changedReport.checkedAt,
      DateRequested: changedReport.dateRequested,
      ReportDate: changedReport.reportDate,
      Passed: changedReport.passed,
      HasFailedTest: changedReport.hasFailedTest,
      TotalTest: changedReport.totalTest,
      VerificationStatusId: changedReport.verificationStatusId
    };
    api.post("COA/ChangeCOAVerificationStatus", payload)
    .then(response => {
      if(response && response.data && response.data.success) {
        this.refreshList();
      }
    }).catch(error => console.log(error))
  }

  markVerified(coaRequestProductId) {
    if (!coaRequestProductId) return;
    api.post(`COA/MarkCoaValidated/${coaRequestProductId}`)
      .then(response => {
        if (response && response.data && response.data.success) {
          this.refreshList();
        }
      }).catch(error => console.log(error))
  }

  downloadReport(coaRequestProductId) {
    if (!coaRequestProductId) return;
    api.postFormDataGetBlob(`COA/DownloadCOAReportXLSX`, {COARequestProductId: coaRequestProductId})
        .then(response => {
          if (response.status === 200) {
            const XLSX_MIME = "application/vnd.openxmlformats-officedocument.spreadsheetml";
            const XLSX_FILENAME = `Product_COA_Test_Results.xlsx`;
            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
              window.navigator.msSaveOrOpenBlob(response.data, XLSX_FILENAME);
            }
            else {
              const file = new Blob([response.data], { type: XLSX_MIME });
              var anchor = window.document.createElement('a');
              anchor.download = XLSX_FILENAME;
              anchor.href = (window.webkitURL || window.URL).createObjectURL(file);
              anchor.dataset.downloadurl = [XLSX_MIME, anchor.download, anchor.href].join(':');
              anchor.click();
            }
          } else {
            throw new Error("Error downloading report");
          }
        }).catch(error => Alert.error(error));
  }

  render() {
    const {
      pagedList
    } = this.state;

    const menuOptions = (
      <div className="sidebarItems">
        <Nav vertical={"true"}>
          {this.state.pagedList && this.state.pagedList.list && this.state.pagedList.length > 0 &&
            this.state.pagedList.list.map((c, coaIndex) => (
              <NavItem key={`${c.coaProductName}-${coaIndex}-${c.coaProductId}`}>
                <Row>
                  <Col>
                    <div>
                      <span
                        className={classnames({ productNotAssociated: !c.productId > 0 ? true : false }, `pl-2 pr-2 ${c.productId > 0 ? "cbdmdBlueText boldText" : ""}`)}
                      >
                        COA Product Name:
                      </span>
                      <span>{c.productName || ""} </span>
                    </div>
                    <div>
                      <span className="boldText">COA Product Sample Name: </span>
                      <span>{c.coaProductName || ""} </span>
                    </div>
                    <div>
                      <span className="boldText">COA Product Sample Name: </span>
                      <span>{c.coaProductName || ""} </span>
                    </div>
                  </Col>
                </Row>
              </NavItem>
            ))}
        </Nav>
      </div>
    );

    return (
      <div className="ml-4 mr-4">
        <Row className="pageTitle p-2 mb-3">
          <Col>
            <h4>Certificate Of Analysis Dashboard</h4>
          </Col>
        </Row>
        <Row className="rowSpacing cursor mb-2">
          <Col>
            <FilterSet
              filters={this.state.filters}
              clearFilters={this.clearFilters}
              childrenClassName="pt-2 cursor"
            >
              <Col xs="3">
                <SelectFilter
                  filterName="productId"
                  displayName="Product"
                  isSingleSelect={true}
                  options={this.state.productList}
                  onChangeCallback={this.onChangeFilter}
                  value={filterHelper.getSelectValue(
                    "productId",
                    this.state.filters
                  )}
                />
              </Col>
              <Col xs="3">
                <SelectFilter
                  filterName="productTypeId"
                  displayName="Product Type"
                  isSingleSelect={true}
                  options={this.state.productTypeList}
                  onChangeCallback={this.onChangeFilter}
                  value={filterHelper.getSelectValue(
                    "productTypeId",
                    this.state.filters
                  )}
                />
              </Col>
              <Col xs="3">
                <SelectFilter
                  filterName="productGroupId"
                  displayName="Product Group"
                  isSingleSelect={true}
                  options={this.state.productGroupList}
                  onChangeCallback={this.onChangeFilter}
                  value={filterHelper.getSelectValue(
                    "productGroupId",
                    this.state.filters
                  )}
                />
              </Col>
              <Col xs="3">
                <TextFilter
                  filterName="sku"
                  displayName="Sku"
                  descriptionPrefix="contains"
                  onChangeCallback={this.onChangeFilter}
                />
              </Col>
              <Col xs="3">
                <SelectFilter
                  filterName="facilityId"
                  displayName="Facility"
                  isSingleSelect={true}
                  options={this.state.facilityList}
                  onChangeCallback={this.onChangeFilter}
                  value={filterHelper.getSelectValue(
                    "facilityId",
                    this.state.filters
                  )}
                />
              </Col>
              <Col xs="3">
                <TextFilter
                  filterName="productName"
                  displayName="Name"
                  descriptionPrefix="contains"
                  onChangeCallback={this.onChangeFilter}
                />
              </Col>
            {/*  <Col xs="3">*/}
            {/*     <TextFilter*/}
            {/*      type="number"*/}
            {/*      filterName="requestedTestId"*/}
            {/*      displayName="Request Log Id"*/}
            {/*      descriptionPrefix="equals"*/}
            {/*      onChangeCallback={this.onChangeFilter}*/}
            {/*    />*/}
            {/*  </Col>*/}
            </FilterSet>
          </Col>
        </Row>
        <Row>
          {this.state.loading ? (
            <Col className="centerText">
              <FontAwesomeIcon icon="spinner" size="9x" spin className={"cbdmdBlueText"} />
            </Col>
          ) : (
            <Col>
              <ListGroup>
                {this.state.pagedList && this.state.pagedList.list && this.state.pagedList.list.length > 0 ? (
                  this.state.pagedList.list.map((c, coaIndex) => (
                    <Card key={`${c.coaProductName}-${coaIndex}-${c.coaProductId}`}
                      className="mb-2 ">
                      <CardHeader onClick={() => this.onProductToggle(coaIndex)}
                        className={classnames({ "failedCOATestResults": c.hasFailedTest}, "cursor coaResult")}
                      >
                        <Row>
                          <Col xs="1" className="p-0 centerText">
                            <GiVial className={`${c.hasFailedTest ? "cbdmdDangerText" : "cbdmdBlueText"}`} size="2x" title={c.collapse ? "Show Less" : "Show More"}/>
                          </Col>
                          <Col>
                            <div>
                              <span className="boldText">Product Name: </span>
                              <span
                                className={classnames({ productNotAssociated: !c.productId > 0 ? true : false }, `pl-2 pr-2 ${c.productId > 0 ? "cbdmdBlueText boldText" : ""}`)}
                              >
                                {c.productName || ""}
                              </span>
                            </div>
                            <div>
                              <span className="boldText">COA Product Sample Name: </span>
                              <span>{c.coaProductName || ""} </span>
                            </div>
                            {c.failedTestTypeNames && 
                                <div>
                                  <span className="boldText cbdmdDangerText">Failed Test Type Names: </span>
                                  <span>{c.failedTestTypeNames || ""} </span>
                                </div>
                            }
                            <div>
                              <span className="boldText">Last Requested On: </span>
                              {moment(c.dateRequested).format("M/DD/YYYY h:mm:ss a")}
                              <span>{}</span>
                            </div>
                          </Col>
                        </Row>
                      </CardHeader>
                      <Collapse isOpen={c.collapse}>
                        <CardBody>
                          <Card body outline color="cbdmdPrimary">
                            {c.reports && c.reports.length > 0 ?
                              (c.reports.map((r, reportIndex) => (
                                <Card key={`report-${reportIndex}-${r.coaRequestProductId}`}>
                                <CardHeader onClick={() => this.onReportToggle(coaIndex, reportIndex)} className="cursor">
                                  <Row>
                                    <Col>
                                      <div>
                                          {r.checkedAt && <span className="boldText cbdmdBlueText">Verified By: {r.checkedByUserName}</span>}
                                      </div>
                                      <div>
                                          {r.checkedAt && <span className="boldText cbdmdBlueText">Date Verified: {moment(r.checkedAt).format("M/DD/YYYY")}</span> }
                                      </div>
                                      <div>
                                          {r.verificationStatusId && <span className="boldText cbdmdBlueText">Verification Status: {(_.find(constant.VerificationStatus, vs => vs.value === r.verificationStatusId).label)}</span> }
                                      </div>
                                      <div>
                                        <span className="boldText">Facility:</span> {r.facilityName}
                                      </div>
                                      <div>
                                         <span className="boldText">Date Requested:</span> {moment(r.dateRequested).format("M/DD/YYYY")}
                                      </div>
                                      {r.failedTestTypeNames && 
                                          <div>
                                                      <span className="boldText cbdmdDangerText">Failed Test Types:</span> {r.failedTestTypeNames}
                                          </div>
                                      }
                                      <div>Total Ingredients Tested: <Badge pill className="cbdmdPrimary">{r.totalTests}</Badge></div>
                                    </Col>
                                    <Col>
                                      {r.hasFailedTest && <div className="float-right" title="Contains failed tests"><RiFlag2Fill size="2em" className={`${r.checkedAt ? "cbdmdWarningText" : "cbdmdDangerText"}`} /></div>}
                                    </Col>
                                  </Row>
                                  </CardHeader>
                                  {r.collapse && 
                                    <CardBody>
                                      <Row>
                                        <Col className="p-2">
                                          <CoaResults
                                          data={r}
                                          markVerified={this.markVerified}
                                          downloadReport={this.downloadReport}
                                          verificationChange={this.onVerificationChange}
                                          />
                                        </Col>
                                      </Row>
                                    </CardBody>
                                  }
                                </Card>
                            ))) : <div>No Results Found</div>}
                          </Card>
                        </CardBody>
                      </Collapse>
                    </Card>
                  ))) : <ListGroupItem>No Results Found</ListGroupItem>}
                  <Pager {...this.state.pagedList} callBack={this.setPage} />
              </ListGroup>
            </Col>
          )}
        </Row>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/COADashboard.js